import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React from 'react';

export default function FormError({
	error,
	spacing = true,
}: {
	error: string;
	spacing?: boolean;
}) {
	return (
		<div
			className={classnames(
				'bg-red-900 flex items-center text-white font-semibold text-base p-2 px-4 rounded-lg',
				{
					'mt-2': spacing === true,
				},
			)}
		>
			<FontAwesomeIcon icon={faInfoCircle} />
			<p className='ml-2'>{error}</p>
		</div>
	);
}
